import { gql } from '@apollo/client/core';

import { SHIFT_FIELDS } from '@/entities/fiscalization';

import { ORDER_FISCAL_OPERATION_FIELDS } from './order-fiscalization.fragments.graphql';

export const OPEN_CASH_SHIFT = gql`
  ${SHIFT_FIELDS}

  mutation OpenCashShift($input: OpenShiftInput!) {
    openShift(input: $input) {
      ...ShiftFields
    }
  }
`;

export const CONFIRM_CASH_SHIFT_KKT = gql`
  ${SHIFT_FIELDS}

  mutation ConfirmCashShiftKkt($input: ConfirmShiftKktInput!) {
    confirmShiftKkt(input: $input) {
      ...ShiftFields
    }
  }
`;

export const ABORT_CASH_SHIFT_OPENING = gql`
  ${SHIFT_FIELDS}

  mutation AbortCashShiftOpening($shiftId: ID!) {
    abortShiftOpening(shiftId: $shiftId) {
      ...ShiftFields
    }
  }
`;

export const CASH_SHIFT_CLOSING_CONTEXT = gql`
  ${SHIFT_FIELDS}
  ${ORDER_FISCAL_OPERATION_FIELDS}

  query CashShiftClosingContext($shiftId: ID!) {
    shiftClosingContext(shiftId: $shiftId) {
      shift {
        ...ShiftFields
      }
      revenue_mors_cash
      revenue_mors_card
      revenue_mors_other
      revenue_mors_total
      pending_operations {
        ...OrderFiscalOperationFields
      }
    }
  }
`;

export const START_CASH_SHIFT_CLOSING = gql`
  ${SHIFT_FIELDS}
  ${ORDER_FISCAL_OPERATION_FIELDS}

  mutation StartCashShiftClosing($shiftId: ID!) {
    startShiftClosing(shiftId: $shiftId) {
      shift {
        ...ShiftFields
      }
      revenue_mors_cash
      revenue_mors_card
      revenue_mors_other
      revenue_mors_total
      pending_operations {
        ...OrderFiscalOperationFields
      }
    }
  }
`;

export const CLOSE_CASH_SHIFT = gql`
  ${SHIFT_FIELDS}

  mutation CloseCashShift($input: CloseShiftInput!) {
    closeShift(input: $input) {
      ...ShiftFields
    }
  }
`;

export const CANCEL_CASH_SHIFT_CLOSING = gql`
  ${SHIFT_FIELDS}

  mutation CancelCashShiftClosing($shiftId: ID!) {
    cancelShiftClosing(shiftId: $shiftId) {
      ...ShiftFields
    }
  }
`;

export const REGISTER_CASH_SHIFT_KKT_REOPEN = gql`
  ${SHIFT_FIELDS}

  mutation RegisterCashShiftKktReopen($input: RegisterShiftKktReopenInput!) {
    registerShiftKktReopen(input: $input) {
      ...ShiftFields
    }
  }
`;

export const FORCE_CLOSE_CASH_SHIFT = gql`
  ${SHIFT_FIELDS}

  mutation ForceCloseCashShift($input: ForceCloseShiftInput!) {
    forceCloseShift(input: $input) {
      ...ShiftFields
    }
  }
`;
